import dayjs from 'dayjs';
import { RiCalendarLine } from 'react-icons/ri';
import styles from './StudyCardMeta.module.css';

interface StudyCardMetaProps {
  studyDateTime: string;
  readingPhysicianName: string;
}

export default function StudyCardMeta({
  studyDateTime,
  readingPhysicianName,
}: StudyCardMetaProps) {
  const d = dayjs(studyDateTime);
  const date = d.format('MMM D, YYYY');
  const time = d.format('h:mm A');

  return (
    <div className={styles.meta}>
      <RiCalendarLine className={styles.icon} />
      <span>
        {date} · {time}
      </span>
      {readingPhysicianName && (
        <>
          <span className={styles.separator}>·</span>
          <span className={styles.physician}>{readingPhysicianName}</span>
        </>
      )}
    </div>
  );
}
